(function () {
  if (window.__videoTrackingInit) return;
  window.__videoTrackingInit = true;

  var GTM_TRIGGER_ID = '2277012_1484';
  var PROGRESS_SECONDS = [1, 4, 10, 15, 20];

  var SELECTOR = 'iframe[data-video-track]';
  var bound = new WeakSet();

  function loadYouTubeApi() {
    if (window.YT && window.YT.Player) return;
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) return;
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.async = true;
    document.head.appendChild(tag);
  }

  function onApiReady(cb) {
    var tries = 0;
    (function check() {
      if (window.YT && window.YT.Player) return cb();
      if (++tries > 120) return;
      setTimeout(check, 500);
    })();
  }

  function isVisible(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
  }

  function pushVideoEvent(player, iframe, status, currentTime) {
    var duration = Math.round(player.getDuration() || 0);
    var videoData = player.getVideoData ? player.getVideoData() : {};

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gtm.video',
      'gtm.triggers': GTM_TRIGGER_ID,
      'gtm.videoProvider': 'youtube',
      'gtm.videoStatus': status,
      'gtm.videoUrl': player.getVideoUrl ? player.getVideoUrl() : '',
      'gtm.videoTitle': videoData.title || '',
      'gtm.videoDuration': duration,
      'gtm.videoCurrentTime': currentTime,
      'gtm.videoPercent': duration ? Math.round(currentTime / duration * 100) : 0,
      'gtm.videoVisible': isVisible(iframe)
    });
  }

  function bind(iframe) {
    if (bound.has(iframe)) return;
    bound.add(iframe);

    var started = false;
    var sentProgress = {};
    var timer = null;

    function checkProgress(player) {
      var t = player.getCurrentTime() || 0;
      PROGRESS_SECONDS.forEach(function (s) {
        if (!sentProgress[s] && t >= s) {
          sentProgress[s] = true;
          pushVideoEvent(player, iframe, 'progress', s);
        }
      });
    }

    new YT.Player(iframe, {
      events: {
        onStateChange: function (e) {
          var player = e.target;
          clearInterval(timer);
          if (e.data !== YT.PlayerState.PLAYING) return;

          if (!started) {
            started = true;
            pushVideoEvent(player, iframe, 'start', Math.round(player.getCurrentTime() || 0));
          }
          timer = setInterval(function () { checkProgress(player); }, 500);
        }
      }
    });
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(bind);
  }

  function init() {
    loadYouTubeApi();
    onApiReady(function () {
      scan();
      var debounce;
      new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(scan, 200);
      }).observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 0);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 0); });
  }
})();
